/**
 * @description 系统时间校准(单例)
 * @class SystemClock
 */
class SystemClock {
  // 当前时间与系统时间偏移量
  private offset = 0;

  now() {
    return Date.now() + (this.offset || 0);
  }

  handleOffset(serverDate: string) {
    const serverTime = Date.parse(serverDate);
    // 本地时间与服务器时间相差大于等于30s则需要进行校准
    if (Math.abs(this.now() - serverTime) >= 30000) {
      this.offset = serverTime - Date.now();
      logger.ui('[SystemClock] 时间校准偏移量', this.offset);
    }
  }
}

export default new SystemClock();
